import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.number.constructor.js";
// Copyright 2021-2022 @skyekiwi/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { decodeAddress, encodeAddress } from '@polkadot/keyring';

var hexToU8a = function hexToU8a(hex) {
  if (isValidHex(hex)) {
    return new Uint8Array(hex.match(/[0-9A-Fa-f]{1,2}/g).map(function (byte) {
      return parseInt(byte, 16);
    }));
  } else {
    throw new Error('invalid hex string: Util.hexToU8a');
  }
};

var u8aToHex = function u8aToHex(bytes) {
  return bytes.reduce(function (str, byte) {
    return str + byte.toString(16).padStart(2, '0');
  }, '');
};

var isValidHex = function isValidHex(str) {
  return (str.length & 1) === 0 && /^[0-9A-Fa-f]*$/g.test(str);
};

var toBase64 = function toBase64(x) {
  return Buffer.from(x, 'binary').toString('base64');
};

var fromBase64 = function fromBase64(x) {
  return Buffer.from(x, 'base64').toString('binary');
};

var numberPadding = function numberPadding(n) {
  return String(n).padStart(16, '0');
};

var trimEnding = function trimEnding(str) {
  var len = str.length;

  if (str[len - 1] === '|' || str[len - 1] === '-' || str[len - 1] === ' ' || str[len - 1] === '?') {
    return str.substring(0, len - 1);
  } else return str;
};

var stringToU8a = function stringToU8a(str) {
  return new TextEncoder().encode(str);
};

var u8aToString = function u8aToString(u8a) {
  return new TextDecoder('utf-8').decode(u8a);
};

var indexToString = function indexToString(index) {
  var hexStarting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (hexStarting ? '0x' : '') + index.toString(16).padStart(8, '0');
};

var stringToIndex = function stringToIndex(index) {
  if (index.indexOf('0x') === -1) {
    index = '0x' + index;
  }

  return Number(index);
};

var isValidSubstrateAddress = function isValidSubstrateAddress(address) {
  try {
    encodeAddress(isValidHex(address) ? hexToU8a(address) : decodeAddress(address));
    return true;
  } catch (error) {
    return false;
  }
};

export { stringToIndex, indexToString, isValidSubstrateAddress, hexToU8a, u8aToHex, isValidHex, numberPadding, trimEnding, stringToU8a, u8aToString, toBase64, fromBase64 };